import { formatDate, formatTime } from '@/utils/format';

// Student incident reports (parent-records): shared by My Reports and
// Student Discipline.

export const REPORT_TYPES = [
  { id: 1, name: 'Academic', variant: 'blue' },
  { id: 2, name: 'Disciplinary', variant: 'amber' },
];
export const reportType = (id) => REPORT_TYPES.find((t) => t.id == id) ?? REPORT_TYPES[1];

// Where a report is in its review chain, as seen by the parent.
const STATUSES = [
  { name: 'Class adviser review', variant: 'amber' },
  { name: 'Prefect of Discipline review', variant: 'amber' },
  { name: 'Parent review', variant: 'red' },
];
export const reportStatus = (status) =>
  STATUSES[Number(status)] ?? { name: 'Resolved', variant: 'green' };

// Label/value pairs for <UiDetailList>.
export function reportDetails(report) {
  if (!report) return [];
  return [
    { label: 'Reported by', value: report.teacher_name },
    { label: 'Filed on', value: formatDate(report.created_at) },
    { label: 'Subject', value: report.subject_title },
    { label: 'Grade level', value: report.grade_level },
    { label: 'Date of incident', value: formatDate(report.report_date) },
    { label: 'Time of incident', value: formatTime(report.report_time) },
    { label: 'Description', value: report.report_description || 'No description provided.', span: 2 },
  ];
}

// How serious a case is, set by the Prefect of Discipline once a report
// reaches them. The descriptions are what the "?" help shows; keep them in
// line with the school's student handbook.
export const REPORT_SEVERITIES = [
  {
    id: 'minor',
    name: 'Minor',
    variant: 'green',
    description: 'Improper behavior that does not hurt anyone or damage property. Usually settled with a warning or counseling.',
    examples: 'Tardiness, not wearing the proper uniform, disrupting class, littering.',
  },
  {
    id: 'major',
    name: 'Major',
    variant: 'amber',
    description: 'Deliberate or repeated misconduct that affects other students, staff or school property.',
    examples: 'Cheating, bullying, vandalism, disrespect toward teachers, repeating a minor offense.',
  },
  {
    id: 'severe',
    name: 'Severe',
    variant: 'red',
    description: "Acts that put someone's safety at risk or break the law. May call for the parents and outside authorities.",
    examples: 'Fighting that causes injury, bringing weapons or prohibited substances, theft, threats or harassment.',
  },
];
export const reportSeverity = (id) => REPORT_SEVERITIES.find((s) => s.id === id) ?? null;
